import { BigMath } from "./math";

/**
 * 通用实验分桶判断。
 * 非生产环境默认放行；仅在生产环境按 userId % totalBuckets < threshold 判断是否命中实验组。
 */
export function isInExperimentBucket(
    userId: number | string | null | undefined,
    environment: string | null | undefined,
    totalBuckets: number,
    threshold: number,
): boolean {
    if ( environment !== "production" ) {
        // 不能影响开发和测试
        return true;
    }

    if ( BigMath.lte( totalBuckets, 0 ) || BigMath.lte( threshold, 0 ) ) {
        return false;
    }

    if ( BigMath.lte( userId, 0 ) ) {
        return false;
    }

    const bucket = BigMath.BN( userId ).modulo( totalBuckets ).toNumber();
    return bucket < threshold;
}
